export default "__VITE_ASSET__CyUrsg25__"